import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Button,
  Skeleton,
} from "@mui/material";
import api from "../../../services/api/api";
import Placeholder from "../../../assets/img/placeHolder.png"

const UltimasNoticias = () => {
  const [noticias, setNoticias] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNoticias = async () => {
      try {
        const response = await api.get("/api/getAllNews");
        const filteredNews = response.data
          .filter((noticia) => noticia.isPublished)
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
          .slice(0, 4);
        setNoticias(filteredNews);
      } catch (error) {
        console.error("Erro ao buscar notícias:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchNoticias();
  }, []);

  const handleImageError = (event) => {
    if (!event.target.dataset.failed) {
      event.target.dataset.failed = true;
      event.target.src = Placeholder;
      event.target.style.objectFit = "contain";
      event.target.alt = "Imagem não disponível";
    }
  };

  if (loading) {
    return (
      <Box>
        <Skeleton variant="rectangular" height={400} sx={{ borderRadius: "10px", marginBottom: "16px" }} />
        <Skeleton variant="text" width="60%" />
        <Skeleton variant="text" width="40%" />
        <Skeleton variant="text" width="80%" sx={{ marginBottom: "16px" }} />
      </Box>
    );
  }

  if (noticias.length === 0) {
    return (
      <Typography variant="h6" sx={{ textAlign: "center", marginTop: "20px", color: "#555" }}>
        Nenhuma notícia encontrada.
      </Typography>
    );
  }

  const noticiaDestaque = noticias[0];
  const outrasNoticias = noticias.slice(1);

  return (
    <Box>
      <Grid container spacing={4}>
        <Grid item xs={12} md={8}>
          <Card
            sx={{
              display: "flex",
              flexDirection: "column",
              borderRadius: "10px",
              boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
              height: "100%",
            }}
          >
            <CardMedia
              component="img"
              height="400"
              width="500"
              image={`${noticiaDestaque.CapaImage}`}
              alt={noticiaDestaque.title}
              onError={handleImageError}
              sx={{ borderTopLeftRadius: "10px", borderTopRightRadius: "10px" }}
            />
            <CardContent>
              <Typography variant="body2" color="text.secondary" sx={{ marginBottom: "8px" }}>
                {new Date(noticiaDestaque.createdAt).toLocaleDateString()} • <strong>{noticiaDestaque.category}</strong>
              </Typography>
              <Typography
                variant="h5"
                fontWeight="bold"
                sx={{ fontSize: "20px", marginBottom: "10px", lineHeight: "1.5", color: "#333" }}
              >
                {noticiaDestaque.title}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "start",
                  flexDirection: "column",
                }}
              >
                <Typography
                  component="div"
                  variant="body1"
                  color="text.secondary"
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    flexWrap: "nowrap",
                    overflowY: "hidden",
                    maxHeight: "200px",
                  }}
                >
                  <div dangerouslySetInnerHTML={{ __html: noticiaDestaque.content }} />
                </Typography>
                <Button
                  variant="contained"
                  size="large"
                  color="primary"
                  href={`/noticia/${noticiaDestaque._id}`}
                >
                  Leia mais
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={4}>
          <Grid container spacing={2}>
            {outrasNoticias.map((noticia) => (
              <Grid item xs={12} key={noticia._id}>
                <Card
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: "10px",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  }}
                >
                  <CardMedia
                    component="img"
                    height="120"
                    image={`${noticia.CapaImage}`}
                    alt={noticia.title}
                    onError={handleImageError}
                    sx={{ borderTopLeftRadius: "10px", borderTopRightRadius: "10px" }}
                  />
                  <CardContent>
                    <Typography variant="body2" color="text.secondary" sx={{ marginBottom: "8px" }}>
                      {new Date(noticia.createdAt).toLocaleDateString()} • <strong>{noticia.category}</strong>
                    </Typography>
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      sx={{
                        fontSize: "14px",
                        marginBottom: "10px",
                        lineHeight: "1.4",
                        color: "#333",
                      }}
                    >
                      {noticia.title}
                    </Typography>
                    <Button
                      variant="contained"
                      size="large"
                      color="primary"
                      href={`/noticia/${noticia._id}`}
                    >
                      Leia mais
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default UltimasNoticias;
